const normalizeToolIdentifier = (value = '') => String(value).toLowerCase().replace(/[^a-z0-9]/g, '');

const getToolCandidates = (tool = {}) => [tool.id, tool.name, tool.nameToPass].map(normalizeToolIdentifier);

const matchesAnyCandidate = (tool = {}, candidates = []) => {
    const normalizedCandidates = new Set(candidates.map(normalizeToolIdentifier));
    return getToolCandidates(tool).some((candidate) => normalizedCandidates.has(candidate));
};

export const isWorkspaceMemoryTool = (tool = {}) => matchesAnyCandidate(tool, [
    'Workspace_Brain',
    'Workspace Brain',
    'Workspace Memory',
    'Knowledge Bank',
]);

export const isWebSearchTool = (tool = {}) => matchesAnyCandidate(tool, [
    'Search_The_Web',
    'Web Search',
]);

export const isExploreWebsitesTool = (tool = {}) => matchesAnyCandidate(tool, [
    'Explore_Websites',
    'Explore Websites',
]);

export const isGenerateImageTool = (tool = {}) => matchesAnyCandidate(tool, [
    'Generate_Image',
    'Generate Image',
    'Image Generation',
]);

export const isAssistantEmailTool = (tool = {}) => getToolCandidates(tool).some((candidate) => (
    candidate === 'assistantemail'
    || candidate === 'emailyourself'
    || candidate === 'sendemailtouser'
    || candidate === 'sendemail'
    || candidate === 'emailuser'
));

export const isMaintenanceTool = (tool = {}) => (
    isExploreWebsitesTool(tool)
    || isAssistantEmailTool(tool)
    || isGenerateImageTool(tool)
);

const _HIDDEN_TOOL_NAMES = new Set(['scheduletasks', 'scheduledtasks', 'scheduletask']);
export const shouldHideToolFromOptions = (tool = {}) => getToolCandidates(tool).some(c => _HIDDEN_TOOL_NAMES.has(c)) || isGenerateImageTool(tool);

export const applyToolPresentationOverrides = (tool = {}) => {
    if (isWorkspaceMemoryTool(tool)) {
        return {
            ...tool,
            name: 'Workspace Brain',
            description: 'Use .WorkspaceBrain',
            activeByDefault: true,
            tiers: [],
            order: -1,
        };
    }

    if (isWebSearchTool(tool)) {
        return {
            ...tool,
            name: 'Web Search',
            description: 'Search with Google',
            activeByDefault: true,
            tiers: [],
            order: 0,
        };
    }

    if (isExploreWebsitesTool(tool)) {
        return {
            ...tool,
            name: 'Explore Websites',
            description: 'Read full webpages',
            activeByDefault: false,
            maintenanceMode: true,
            maintenanceLabel: 'MAINT.',
            order: 20,
        };
    }

    if (isAssistantEmailTool(tool)) {
        return {
            ...tool,
            name: 'Assistant Email',
            description: 'Draft or send email',
            activeByDefault: false,
            maintenanceMode: true,
            maintenanceLabel: 'MAINT.',
            order: 30,
        };
    }

    if (isGenerateImageTool(tool)) {
        return {
            ...tool,
            name: 'Generate Image',
            description: 'Create from prompt',
            activeByDefault: false,
            maintenanceMode: true,
            maintenanceLabel: 'MAINT.',
            order: 40,
        };
    }

    return tool;
};